import React, { useEffect } from 'react'

interface useHistoryProps {
  state: string
}

export const useHistory = ({ state }: useHistoryProps) => {
  const [newState, setNewState] = React.useState('')

  useEffect(() => {
    window.history.replaceState(null, '', state)
    setNewState(window.location.href)
  }, [state])

  return { newState }
}
